export default "__VITE_ASSET__CuHqcs4J__"